
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.138 0H.861a.861.861 0 00-.765.455.832.832 0 00.068.884L6.86 10.54l.007.01c.243.32.374.708.375 1.107v7.503a.824.824 0 00.249.593c.16.158.379.246.606.246a.9.9 0 00.338-.066l3.762-1.4c.337-.1.561-.41.561-.784v-6.092c0-.399.132-.787.376-1.107l.006-.01 6.696-9.203c.191-.258.217-.6.068-.883A.861.861 0 0019.138 0zm-6.844 9.95a2.843 2.843 0 00-.577 1.708v5.969l-3.434 1.277v-7.246a2.842 2.842 0 00-.578-1.709l-6.5-8.934h17.59l-6.5 8.934z","fill":"#908F8D"}})])
          )
        }
      }
    